import React from "react";

import { Typography, Box } from "@mui/material";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { useStyles } from "./styles";

const EMPTY_IMG = require("Assets/img/dashboard-no-data.svg");

interface Props {
  retailer?: boolean;
}

export default function NoDataLabel(props: Props) {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  return (
    <>
      <Box className={props?.retailer ? classnames(classes.root, classes.bxMargin) : classes.root}>
        <img src={EMPTY_IMG} alt={translate("noData")} data-cy="emptyImg" />
        <Typography data-cy="emptyText" align="center" className={classes.lblNoData}>
          {translate("itFeelsABitEmpty")}
        </Typography>
      </Box>
    </>
  );
}
